<tax-loader [isMainContent]="true"></tax-loader>
<main>
  <ul>
    <li>
      <a class="menu-item" routerLink="" [class.active]="activeMenuItem === 'login'" translate>
        login.menu
      </a>
    </li>
    <li>
      <a
        class="menu-item"
        (click)="goToRegistrationSelectEds()"
        [class.pseudo-active]="activeMenuItem === 'registration'"
        translate
      >
        login.registration
      </a>
    </li>
  </ul>

  <ul *ngIf="registrationStep" class="registration-steps">
    <li>
      <span class="menu-item" [class.active]="registrationStep === 1">
        1. {{ 'registration.first.step.menu.name' | translate }}
      </span>
    </li>
    <li>
      <span class="menu-item" [class.active]="registrationStep === 2">
        2. {{ 'registration.second.step.menu.name' | translate }}
      </span>
    </li>
  </ul>

  <div class="sidebar_bottom_block">
    <div><span translate>sidebar.ads</span></div>
    <a href="https://apps.apple.com/app/tandau/id1463168753" target="_blank">
      <svg-icon key="app-store-monochrome"></svg-icon>
    </a>
    <a href="https://play.google.com/store/apps/details?id=kz.iberica.tandau" target="_blank">
      <svg-icon key="google-play-monochrome"></svg-icon>
    </a>
  </div>
</main>
